"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRocket = void 0;
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.array.reduce-right.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));
var _react = _interopRequireWildcard(require("react"));
var _configContext = require("./config-context");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * 快速创建 DOM 容器组件
 * @param displayName 组件名称
 * @param paths 组件的容器路径，如 div.tea-card__body
 *
 * tea 类名前缀请使用 `@{prefix}` 代替
 */
var createRocket = exports.createRocket = function createRocket(displayName) {
  for (var _len = arguments.length, paths = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    paths[_key - 1] = arguments[_key];
  }
  var parentOf = function parentOf(classPrefix) {
    return function (children, path) {
      var _path$split = path.split('.'),
        _path$split2 = (0, _toArray2.default)(_path$split),
        tag = _path$split2[0],
        classNames = _path$split2.slice(1);
      return /*#__PURE__*/_react.default.createElement(tag, {
        className: classNames.map(function (c) {
          return c.replace(/^(@{prefix}-)/, "".concat(classPrefix, "-"));
        }).join(' ')
      }, children);
    };
  };
  var Rocket = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
    var children = props.children,
      className = props.className,
      style = props.style;
    var _useConfig = (0, _configContext.useConfig)(),
      classPrefix = _useConfig.classPrefix;
    var element = paths.reduceRight(parentOf(classPrefix), children);
    if (className || style) {
      var elementProps = element.props;
      return /*#__PURE__*/_react.default.cloneElement(element, {
        ref: ref,
        className: [elementProps.className, className].filter(Boolean).join(' '),
        style: style
      });
    }
    return /*#__PURE__*/_react.default.cloneElement(element, {
      ref: ref
    });
  });
  Rocket.displayName = displayName;
  return Rocket;
};